module.exports = __webpack_public_path__ + "img/NewMail.2e8ec267.png";